<app-header></app-header>
<ion-content scrollbar class="ion-content-padding-top-0">
  <app-breadcrumb></app-breadcrumb>

  <div class="testafassfa">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ng-container *ngIf="page === 'orders'">
            <app-search-bar
              #search
              [permissionEdit]="false"
              addLink=""
              buttonAddLabel=""
              (searchEvent)="onChangeSearchOrders($event)"
            ></app-search-bar>
        
            <app-pagination-client-side
              [ngClass]="{'height-0': showLoader}"
              [componentRef]="componentRef"
              [columns]="columnsDefinition"
              (rowsLoaderReady)="rowsLoaderServiceReady($event)"
            ></app-pagination-client-side>

            <div *ngIf="showLoader" class="spin">
              <app-loading-sti></app-loading-sti>
            </div>
          </ng-container>
  
          <ng-container *ngIf="page === 'providers'">
            <app-search-bar
              [permissionEdit]="1"
              gridClass="sb-grid-no-padding"
              (searchEvent)="onChangeSearch($event)"
            ></app-search-bar>
        
            <div class="providers">
              <no-result 
                *ngIf="companiesFilter" 
                [collection]="companiesFilter"
                [text]="noCompanies"
              ></no-result>
              <ion-item
                *ngFor="let item of companiesFilter"
                lines="none"
                routerLink="/app/market/provider/{{item.id}}"
              >
                <ion-thumbnail slot="start">
                  <img *ngIf="item.logo" [src]="item.logo.filePath"/>
                </ion-thumbnail>
        
                <ion-label>
                  {{item.name}}
                  <p>{{item.description}}</p>
                </ion-label>
              </ion-item>
            </div>
          </ng-container>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
